export const CONSTANTES = {
    MENU_TITULO_DASHBOARD: 'dashboard',
    MENU_TITULO_PRODUTOS: 'produtos',
    MENU_TITULO_VENDAS: 'vendas',
    MENU_TITULO_USUARIOS: 'usuarios',
    MENU_TITULO_PERFIL: 'perfil',
    MENU_TITULO_CONFIGURACAO: 'configuracao',
    MENU_TITULO_SAIR: 'sair',
}